import { createContext } from 'react';

import { useSupportedApplications } from 'hooks/useSupportedApplications';

import { SupportedApplications } from 'common/types/supported-applications.type';

export const SupportedApplicationsContext = createContext<{
  isLoading: boolean;
  supportedApplications: SupportedApplications;
}>({
  isLoading: false,
  supportedApplications: undefined,
});

export const SupportedApplicationsProvider = ({ children }) => {
  const { supportedApplications, isLoading } = useSupportedApplications();

  return (
    <SupportedApplicationsContext.Provider
      value={{
        isLoading,
        supportedApplications,
      }}
    >
      {children}
    </SupportedApplicationsContext.Provider>
  );
};
